import { SignalStore } from '@awork/core/state/signal-store/signalStore'
import { Injectable } from '@angular/core'
import type { AccountState } from '@awork/_shared/models/account.model'
import { Account } from '@awork/_shared/models/account.model'

function createInitialState(): AccountState {
  return {
    email: null,
    id: null,
    firstName: null,
    lastName: null,
    language: null,
    timezone: null,
    refreshToken: null,
    accessToken: null,
    refreshAt: null,
    isImpersonated: false,
    passwordIsAutoGenerated: null,
    emailConfirmed: null,
    googleUserId: null,
    appleUserId: null,
    externalAccounts: [],
    mfaEnabled: null,
    mfaProviders: [],
    passwordlessEnabled: null
  }
}

@Injectable({ providedIn: 'root' })
export class AccountStore extends SignalStore<AccountState> {
  constructor() {
    super({ name: 'account', initialState: createInitialState() })
  }

  updateAccount(accountState: Partial<AccountState>): void {
    if (accountState.email) {
      const impersonatedAccount = new Account(accountState.email)

      accountState.isImpersonated = impersonatedAccount.isImpersonated
    }

    this.update(accountState)
  }
}
